import Logger from '../Logger';

const logger = new Logger();

const initialState =
{
	name                          : '',
	joinedTime                    : parseInt(Date.now()/1000),  // 入会时间
	// new/connecting/connected/disconnected/closed,
	state                         : 'new',
	locked                        : false,
	inLobby                       : false,
	signInRequired                : false,
	overRoomLimit                 : false,
	// access code to the room if locked and joinByAccessCode == true
	accessCode                    : '',
	// if true: accessCode is a possibility to open the room
	joinByAccessCode              : true,
	activeSpeakerId               : null,

	filmstripSelectedId           : null,
	torrentSupport                : false,
	showSettings                  : false,
	fullScreenConsumerId          : null,    // 全屏窗口中的ConsumerId
	newWindowOpen                 : false,   // 应用中是否有新窗口
	windowConsumerId              : null,    // 新窗口中的ConsumerId
	windowPeerId                  : null,    // 新窗口中的PeerId
	hoverPeerId                   : null,    // 主持人模式下参会人列表页获取焦点的PeerId
	windowVideoSource             : '',      // 新窗口中的视频类型 screen \ webcam
	toolbarsVisible               : true,
	topBarMoreAnchorEl            : null,    // 顶部导航栏菜单
	forceMode                     : false,   // 是否开启强制同步模式
	screenSharing                 : false,   // 会议室是否有共享
	myScreenSharing               : false,   // 自已在共享视频
	historyMode                   : [window.config.defaultLayout || 'speaker'],   // 历史模式(保存被动切换之前的模式)
	mode                          : window.config.defaultLayout || 'speaker',

	layoutConfig                  : window.viewsLayout[window.config.defaultLayout || 'speaker'],  // 布局配置
	layoutOpen                    : false,   // 打开布局对话框
	voteOpen                      : false,   // 打开投票对话框
	currentLayoutTab              : 'edit',  // edit, list
	remoteFilterVideo             : false,   // 是否为远程过滤
	filterVideo                   : false,   // 是否过滤无图像视频

	spotlights                    : [],
	settingsOpen                  : false,
	extraVideoOpen                : false,
	helpOpen                      : false,
	aboutOpen                     : false,
	currentSettingsTab            : 'audio', // volume, video, virtualBg, appearance
	lockDialogOpen                : false,
	joined                        : false,
	muteAllInProgress             : false,
	forceMuteAllInProgress        : false,
	lobbyPeersPromotionInProgress : false,
	stopAllVideoInProgress        : false,
	closeMeetingInProgress        : false,
	clearChatInProgress           : false,
	clearFileSharingInProgress    : false,
	windowOpenName                : 'huijian',
	roomPermissions               : null,
	allowWhenRoleMissing          : null,
	joinError                     : { hasError: false, errorCode: '' },
	hideSelfView                  : false,
	config                        : null,    // 当前会议室状态
	confId                        : null,
	delaying                      : false,   // 延时处理
	shutting                      : false,
	rollcall                      : false,   // 是否点名中
	snackBarOpen                  : false,   // 是否显示推送消息框
	snackBarTipType               : '',      // 消息框内容的类型

	voteUpdated                   : { type: '', userId: 0, surveyId: 0 },  // 投票更新: 类型;终端Id;投票Id
	joining                       : false,    // false: token 连接可以入会; true: 入会中,等待通知,token 连接不可以入会

	chairPeerId                   : null,     // 主持人id
	lockPeerId                    : null,     // 焦点id

	isForceMuteAll                : false,    // 主持人模式下强制静音

	meIsRecording                 : false,    // 当前终端是否正在录制
	hasRecording                  : false,    // 会中是否有录制
	recordErrCode                 : 0,        // 会中录制错误码

	signOutOpen                   : false,    // 结束/离开会议确认框
	raiseHandPeerId               : null,     // 当前会议室举手终端
	auditRaiseHandOpen            : false,    // 主持人审核发言确认框
	forceMuteAllOpen              : false,    // 主持人强制静音确认框

	recordConfirmOpen             : false,    // 主持人录制确认框

	voteEnable                    : '1',      // 会议是否开启了投票

	subtitleOpen                  : false,    // 是否开启实时字幕
	subtitleEnable                : 1,        // 显示/隐藏实时字幕功能  1: 隐藏; 2:显示
	subtitleState                 : 1,        // 会中是否允许非主持人开启实时字幕(1: 关闭; 2: 开启)
	subtitleErrCode               : 0,        // 实时字幕错误码
	recordingPromptEnable         : false,    // 是否开启录制提醒
	hasRecordingPrompt            : false,    // 是否需要录制提醒
	cohostSuids                   : [],       // 联席主持人列表
	watermark                     : null      // 水印配置信息
};

const room = (state = initialState, action) =>
{
	switch (action.type)
	{

		case 'SET_IS_FORCE_MUTE_ALL':
		{
			const { flag } = action.payload;

			return {
				...state,
				isForceMuteAll: flag
			};
		}

		case 'SET_ME_IS_RECORDING':
		{
			const { flag } = action.payload;

			return {
				...state,
				meIsRecording: flag
			};
		}

		case 'SET_HAS_RECORDING':
		{
			const { flag } = action.payload;

			return {
				...state,
				hasRecording: flag
			};
		}

		case 'SET_RECORD_ERR_CODE':
		{
			const { errCode } = action.payload;

			return {
				...state,
				recordErrCode : errCode
			};
		}

		case 'SET_SIGN_OUT_OPEN':
		{
			const { flag } = action.payload;

			return {
				...state,
				signOutOpen: flag
			};
		}

		case 'SET_RAISE_HAND_PEER_ID':
		{
			const { peerId } = action.payload;

			return {
				...state,
				raiseHandPeerId: peerId
			};
		}

		case 'SET_AUDIT_RAISE_HAND_OPEN':
		{
			const { flag } = action.payload;

			return {
				...state,
				auditRaiseHandOpen: flag
			};
		}

		case 'SET_FORCE_MUTE_ALL_OPEN':
		{
			const { flag } = action.payload;

			return {
				...state,
				forceMuteAllOpen: flag
			};
		}

		case 'SET_RECORD_CONFIRM_OPEN':
		{
			const { flag } = action.payload;

			return {
				...state,
				recordConfirmOpen: flag
			};
		}

		case 'SET_WATERMARK':
		{
			const { watermark } = action.payload;

			return {
				...state,
				watermark
			};
		}

		case 'SET_SNACKBAR_OPEN':
		{
			const { flag } = action.payload;

			return {
				...state,
				snackBarOpen: flag
			};
		}

		case 'SET_SNACKBAR_TIP_TYPE':
		{
			const { tipType } = action.payload;

			return {
				...state,
				snackBarTipType: tipType
			};
		}

		case 'SET_VOTE_UPDATED':
		{
			const { voteUpdated } = action.payload;

			return {
				...state,
				voteUpdated
			};
		}

		case 'SET_JOINING':
		{
			const { flag } = action.payload;

			return {
				...state,
				joining: flag
			};
		}

		case 'SET_WINDOW_OPEN_NAME':
		{
			const { windowOpenName } = action.payload;

			return {
				...state,
				windowOpenName
			};
		}

		case 'SET_ROOM_NAME':
		{
			const { name } = action.payload;

			return {
				...state,
				name
			};
		}

		case 'SET_ROOM_STATE':
		{
			const roomState = action.payload.state;

			if (roomState === 'connected')
				return {
					...state,
					state: roomState
				};
			else
				return {
					...state,
					state: roomState,
					activeSpeakerId: null
				};
		}

		case 'SET_ROOM_LOCKED':
		{
			return {
				...state,
				locked: true
			};
		}

		case 'SET_ROOM_DELAYING':
		{
			const { flag } = action.payload;

			return {
				...state,
				delaying: flag
			};
		}

		case 'SET_ROOM_SHUTTING':
		{
			const { flag } = action.payload;

			return {
				...state,
				shutting: flag
			};
		}

		case 'SET_ROOM_UNLOCKED':
		{
			return {
				...state,
				locked: false
			};
		}

		case 'SET_IN_LOBBY':
		{
			const { inLobby } = action.payload;

			return {
				...state,
				inLobby
			};
		}

		case 'SET_FILMSTRIP_SELECTED_ID':
		{
			const { peerId } = action.payload;

			return {
				...state,
				filmstripSelectedId : peerId
			};
		}

		case 'SET_SIGN_IN_REQUIRED':
		{
			const { signInRequired } = action.payload;

			return {
				...state,
				signInRequired
			};
		}
		case 'SET_OVER_ROOM_LIMIT':
		{
			const { overRoomLimit } = action.payload;

			return {
				...state,
				overRoomLimit
			};
		}
		case 'SET_ACCESS_CODE':
		{
			const { accessCode } = action.payload;

			return {
				...state,
				accessCode
			};
		}

		case 'SET_JOIN_BY_ACCESS_CODE':
		{
			const { joinByAccessCode } = action.payload;

			return {
				...state,
				joinByAccessCode
			};
		}

		case 'SET_LOCK_DIALOG_OPEN':
		{
			const { lockDialogOpen } = action.payload;

			return {
				...state,
				lockDialogOpen
			};
		}

		case 'SET_SHARE_DIALOG_OPEN':
		{
			const { shareDialogOpen } = action.payload;

			return {
				...state,
				shareDialogOpen
			};
		}

		case 'SET_SETTINGS_OPEN':
		{
			const { settingsOpen } = action.payload;

			return {
				...state,
				settingsOpen
			};
		}

		case 'SET_EXTRA_VIDEO_OPEN':
		{
			const { extraVideoOpen } = action.payload;

			return {
				...state,
				extraVideoOpen
			};
		}

		case 'SET_HELP_OPEN':
		{
			const { helpOpen } = action.payload;

			return {
				...state,
				helpOpen
			};
		}

		case 'SET_ABOUT_OPEN':
		{
			const { aboutOpen } = action.payload;

			return {
				...state,
				aboutOpen
			};
		}

		case 'SET_SETTINGS_TAB':
		{
			const { tab } = action.payload;

			return {
				...state,
				currentSettingsTab: tab
			};
		}

		case 'SET_ROOM_ACTIVE_SPEAKER':
		{
			const { peerId } = action.payload;

			return {
				...state,
				activeSpeakerId: peerId
			};
		}

		case 'FILE_SHARING_SUPPORTED':
		{
			const { supported } = action.payload;

			return {
				...state,
				torrentSupport: supported
			};
		}

		case 'SET_JOINED':
		{
			const { flag }  = action.payload;

			return {
				...state,
				joined: flag
			};
		}

		case 'SET_ROLLCALL':
		{
			const { flag }  = action.payload;

			return {
				...state,
				rollcall: flag
			};
		}

		case 'TOGGLE_FULLSCREEN_CONSUMER':
		{
			const { consumerId } = action.payload;
			const currentConsumer = state.fullScreenConsumerId;

			return {
				...state,
				fullScreenConsumerId: currentConsumer ? null : consumerId
			};
		}

		case 'CLOSE_FULLSCREEN_CONSUMER':
		{

			return {
				...state,
				fullScreenConsumerId: null
			};
		}

		case 'TOGGLE_WINDOW_CONSUMER':
		{
			const { consumerId } = action.payload;
			const currentConsumer = state.windowConsumerId;

			if (currentConsumer === consumerId)
				return {
					...state,
					windowConsumerId: null
				};
			else
				return {
					...state,
					windowConsumerId: consumerId
				};
		}
		case 'SET_WINDOW_CONSUMER_ID':
		{
			const { consumerId } = action.payload;

			return {
				...state,
				windowConsumerId: consumerId
			};
		}

		case 'TOGGLE_WINDOW_PEER_ID':
		{
			const { peerId } = action.payload;
			const currentPeerId = state.windowPeerId;

			if (currentPeerId === peerId)
				return {
					...state,
					windowPeerId: null
				};
			else
				return {
					...state,
					windowPeerId: peerId
				};
		}
		case 'SET_WINDOW_PEER_ID':
		{
			const { peerId } = action.payload;

			return {
				...state,
				windowPeerId: peerId
			};
		}

		case 'TOGGLE_WINDOW_VIDEO_SOURCE':
		{
			const { videoSource } = action.payload;
			const currentVideoSource = state.windowVideoSource;

			if (currentVideoSource === videoSource)
				return {
					...state,
					windowVideoSource: null
				};
			else
				return {
					...state,
					windowVideoSource: videoSource
				};
		}
		case 'SET_WINDOW_VIDEO_SOURCE':
		{
			const { videoSource } = action.payload;

			return {
				...state,
				windowVideoSource: videoSource
			};
		}

		case 'SET_HOVER_PEER_ID':
		{
			const { peerId } = action.payload;

			return {
				...state,
				hoverPeerId: peerId
			};
		}

		case 'NEW_WINDOW_OPEN':
		{
			const { flag } = action.payload;

			return {
				...state,
				newWindowOpen: flag
			};
		}

		case 'SET_TOOLBARS_VISIBLE':
		{
			const { toolbarsVisible } = action.payload;

			return {
				...state,
				toolbarsVisible
			};
		}

		case 'SET_TOP_BAR_MORE_ANCHOREL':
		{
			const { target } = action.payload;

			return {
				...state,
				topBarMoreAnchorEl : target
			};
		}

		case 'SET_FORCE_MODE': {
			return {
				...state,
				forceMode: action.payload.flag
			};
		}

		case 'SET_SCREEN_SHARING': {
			return {
				...state,
				screenSharing: action.payload.flag
			};
		}

		case 'SET_MY_SCREEN_SHARING': {
			return {
				...state,
				myScreenSharing: action.payload.flag
			};
		}

		case 'SET_HISTORY_MODE': {
			return {
				...state,
				historyMode: action.payload.mode
			};
		}

		case 'SET_DISPLAY_MODE': {
			return {
				...state,
				mode: action.payload.mode
			};
		}

		case 'SET_LAYOUT_CONFIG':
		{
			const { layoutConfig } = action.payload;

			const _layoutConfig = JSON.parse(JSON.stringify(layoutConfig));

			logger.debug('store 中 layoutConfig 项被修改', JSON.stringify(_layoutConfig));

			return {
				...state,
				layoutConfig: _layoutConfig
			};
		}

		case 'SET_LAYOUT_OPEN':
		{
			const { layoutOpen } = action.payload;

			return {
				...state,
				layoutOpen
			};
		}

		case 'SET_VOTE_OPEN':
		{
			const { voteOpen } = action.payload;

			return {
				...state,
				voteOpen
			};
		}

		case 'SET_SUBTITLE_OPEN':
		{
			const { subtitleOpen } = action.payload;

			return {
				...state,
				subtitleOpen
			};
		}

		case 'SET_LAYOUT_TAB':
		{
			const { tab } = action.payload;

			return {
				...state,
				currentLayoutTab: tab
			};
		}

		case 'TOGGLE_FILTER_VIDEO':
		{

			const filterVideo = !state.filterVideo;

			return {
				...state,
				filterVideo
			};
		}

		case 'SET_REMOTE_FILTER_VIDEO':
		{

			return {
				...state,
				remoteFilterVideo: action.payload.flag
			};
		}

		case 'SET_FILTER_VIDEO':
		{

			return {
				...state,
				filterVideo: action.payload.flag
			};
		}

		case 'SET_SPOTLIGHTS':
		{
			const { spotlights } = action.payload;

			return {
				...state,
				spotlights
			};
		}

		case 'CLEAR_SPOTLIGHTS':
		{
			return {
				...state,
				spotlights: []
			};
		}

		case 'SET_LOBBY_PEERS_PROMOTION_IN_PROGRESS':
			return {
				...state,
				lobbyPeersPromotionInProgress: action.payload.flag
			};

		case 'MUTE_ALL_IN_PROGRESS':
			return {
				...state,
				muteAllInProgress: action.payload.flag
			};

		case 'FORCE_MUTE_ALL_IN_PROGRESS':
			return {
				...state,
				forceMuteAllInProgress: action.payload.flag
			};

		case 'STOP_ALL_VIDEO_IN_PROGRESS':
			return {
				...state,
				stopAllVideoInProgress: action.payload.flag
			};

		case 'STOP_ALL_SCREEN_SHARING_IN_PROGRESS':
			return {
				...state,
				stopAllScreenSharingInProgress: action.payload.flag
			};

		case 'CLOSE_MEETING_IN_PROGRESS':
			return {
				...state,
				closeMeetingInProgress: action.payload.flag
			};

		case 'CLEAR_CHAT_IN_PROGRESS':
			return {
				...state,
				clearChatInProgress: action.payload.flag
			};

		case 'CLEAR_FILE_SHARING_IN_PROGRESS':
			return {
				...state,
				clearFileSharingInProgress: action.payload.flag
			};

		case 'SET_ROOM_PERMISSIONS':
		{
			const { roomPermissions } = action.payload;

			return {
				...state,
				roomPermissions
			};
		}

		case 'SET_ALLOW_WHEN_ROLE_MISSING':
		{
			const { allowWhenRoleMissing } = action.payload;

			return {
				...state,
				allowWhenRoleMissing
			};
		}

		case 'TOGGLE_SELF_VIEW':
		{
			const { flag } = action.payload;

			return {
				...state,
				hideSelfView : flag
			};
		}

		case 'SET_JOIN_ERROR':
		{
			const { joinError } = action.payload;

			const newJoinError = {
				...state.joinError,
				...joinError
			};

			return {
				...state,
				joinError: newJoinError
			};
		}

		case 'SET_CONFIG':
		{
			const { config } = action.payload;

			return {
				...state,
				config
			};
		}

		case 'SET_CONF_ID':
		{
			const { confId } = action.payload;

			return {
				...state,
				confId
			};
		}

		case 'SET_CHAIR_PEER_ID':
		{
			const { peerId } = action.payload;

			return {
				...state,
				chairPeerId: peerId
			};
		}

		case 'SET_LOCK_PEER_ID':
		{
			const { peerId } = action.payload;

			return {
				...state,
				lockPeerId: peerId
			};
		}

		case 'SET_VOTE_ENABLE':
		{
			const { flag } = action.payload;
			return {
				...state,
				voteEnable : flag
			};
		}

		case 'SET_SUBTITLE_ENABLE':
		{
			const { flag } = action.payload;
			return {
				...state,
				subtitleEnable : flag
			};
		}

		case 'SET_SUBTITLE_STATE':
		{
			const { subtitleState } = action.payload;
			return {
				...state,
				subtitleState
			};
		}

		case 'SET_SUBTITLE_ERR_CODE':
		{
			const { errCode } = action.payload;

			return {
				...state,
				subtitleErrCode : errCode
			};
		}

		case 'SET_RECORDING_PROMPT_ENABLE':
		{
			const { flag } = action.payload;

			return {
				...state,
				recordingPromptEnable : flag
			};
		}

		case 'SET_HAS_RECORDING_PROMPT':
		{
			const { flag } = action.payload;

			return {
				...state,
				hasRecordingPrompt : flag
			};
		}
		
		case 'SET_COHOST_SUIDS':
		{
			const { suids } = action.payload;

			return {
				...state,
				cohostSuids : suids
			};
		}

		case 'ADD_COHOST_SUID':
		{
			const { suid } = action.payload;

			const newCohostSuids = [...state.cohostSuids, suid];

			return {
				...state,
				cohostSuids : newCohostSuids
			};
		}

		case 'REMOVE_COHOST_SUID':
		{
			const { suid } = action.payload;

			const newCohostSuids = state.cohostSuids.filter((cohostSuid) => cohostSuid !== suid);

			return {
				...state,
				cohostSuids : newCohostSuids
			};
		}

		default:
			return state;
	}
};

export default room;
